import axios from 'axios'
import { API_URL } from '@/configs/site-settings'
import { store } from '@/redux/store'
import { logout, refresToken } from '@/redux/features/userSlice'
import { loadLocalState, saveLocalState } from '@/utils/storage'

// Shared in-flight refresh: parallel 401s wait for one refresh call instead of
// each spending the refresh token on its own request.
let refreshPromise: Promise<string | null> | null = null

const requestNewAccessToken = async (): Promise<string | null> => {
  const refresh_token = loadLocalState('user')?.refresh
  if (!refresh_token) {
    store.dispatch(logout())
    return null
  }

  try {
    const response = await axios.post<{ access: string; refresh?: string }>(
      `${API_URL}users/refresh/`,
      { refresh: refresh_token }
    )
    store.dispatch(refresToken(response.data.access))
    // Keep a rotated refresh token if the server issues one
    if (response.data.refresh) {
      saveLocalState('user', {
        ...loadLocalState('user'),
        refresh: response.data.refresh,
      })
    }
    return response.data.access
  } catch (error) {
    console.error('Failed to refresh token:', error)
    // Only a rejected refresh token ends the session; network/server failures
    // are rethrown so the caller fails the request without logging out.
    const status = axios.isAxiosError(error)
      ? error.response?.status
      : undefined
    if (status === 400 || status === 401) {
      store.dispatch(logout())
      return null
    }
    throw error
  }
}

export const refreshAccessToken = (): Promise<string | null> => {
  if (!refreshPromise) {
    refreshPromise = requestNewAccessToken().finally(() => {
      refreshPromise = null
    })
  }
  return refreshPromise
}
